'use strict';

import {
	RESET_STATE,
	UPDATE_BATCH_FORM,
	ADD_BATCH_LIST,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	SET_WORKPLACE_WAITING_TIME_GRID,
	UPDATE_WORKPLACE_WAITING_TIME_GRID,
} from './workplaceWaitingTimeGrids.actions';

const defaultState = {
	data: {
		defaultWorkplaceWaitingTimeGrid: {},
		batchFormData: {
			state: {
				value: 'Draft',
				label: 'Draft',
			},
		},
		batchListData: [],
	},
};

function reducer(state = defaultState, action) {
	const { payload, type } = action;

	switch (type) {
	case UPDATE_BATCH_FORM: {
		return {
			...state,
			data: {
				...state.data,
				batchFormData: {
					...state.data.batchFormData,
					...payload,
				},
			},
		};
	}

	case ADD_BATCH_LIST: {
		return {
			...state,
			data: {
				...state.data,
				batchListData: payload,
			},
		};
	}

	case EDIT_BATCH_LIST_ITEM: {
		return {
			...state,
			data: {
				...state.data,
				batchListData: state.data.batchListData.map((entry) => {
					if (entry.identifier === payload.identifier) return payload;
					return entry;
				}),
			},
		};
	}

	case REMOVE_BATCH_LIST_ITEM: {
		return {
			...state,
			data: {
				...state.data,
				batchListData: state.data.batchListData.filter(
					(entry) => entry.identifier !== payload
				),
			},
		};
	}

	case SET_WORKPLACE_WAITING_TIME_GRID: {
		return {
			...state,
			data: {
				...state.data,
				defaultWorkplaceWaitingTimeGrid: payload,
			},
		};
	}

	case UPDATE_WORKPLACE_WAITING_TIME_GRID: {
		return {
			...state,
			data: {
				...state.data,
				defaultWorkplaceWaitingTimeGrid: {
					...state.data.defaultWorkplaceWaitingTimeGrid,
					...payload,
				},
			},
		};
	}

	case RESET_STATE: {
		return defaultState;
	}

	default:
		// never return default state in default case, Filip!!!
		return state;
	}
}

export default reducer;
